import { useState, useEffect, useRef } from 'react';
import { useUI }       from '../../context/UIContext';
import { useCart }     from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import { useCurrency } from '../../context/CurrencyContext';
import { buildEnquiryMessage } from '../../lib/whatsapp';
import { getProducts } from '../../lib/api';
import ProductCard from '../shop/ProductCard';
import { trackProduct } from '../../screens/RecentlyViewed';
import { imgSrc } from '../../lib/env';
// const imgSrc = (url) => !url ? null : url.startsWith('http') ? url : `http://localhost${url}`;

function parseArr(val) {
  if (Array.isArray(val)) return val;
  if (typeof val === 'string' && val) {
    try { return JSON.parse(val); } catch { return []; }
  }
  return [];
}

export default function QuickViewModal() {
  const { qvProduct, closeQV, openCheckout } = useUI();
  const { addItem }               = useCart();
  const { toggle, isWishlisted }  = useWishlist();
  const { fmt }                   = useCurrency();
  const [activeIdx,     setActiveIdx]     = useState(0);
  const [selectedColor, setSelectedColor] = useState(null);
  const [allProducts,   setAllProducts]   = useState([]);
  const [paused,        setPaused]        = useState(false);
  const scrollRef = useRef(null);
  const p = qvProduct;

  const [imagePopup, setImagePopup] = useState(false);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    getProducts().then(d => setAllProducts(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (p) {
      setActiveIdx(0);
      setPaused(false);
      setSelectedColor(null);
      if (scrollRef.current) scrollRef.current.scrollTop = 0;
      trackProduct(p);
    }
  }, [p]);

  // Auto-carousel
  useEffect(() => {
    if (!p || paused) return;
    const imgs = [p.img, ...parseArr(p.images)].filter(Boolean);
    if (imgs.length < 2) return;
    const t = setInterval(() => setActiveIdx(i => (i + 1) % imgs.length), 3500);
    return () => clearInterval(t);
  }, [p, paused]);

  useEffect(() => {
    if (p) document.body.style.overflow = 'hidden';
    else    document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [p]);

  useEffect(() => {
    const fn = (e) => { if (e.key === 'Escape') closeQV(); };
    document.addEventListener('keydown', fn);
    return () => document.removeEventListener('keydown', fn);
  }, [closeQV]);

  if (!p) return null;

  const allImgs    = [p.img, ...parseArr(p.images)].filter(Boolean).map(imgSrc);
  const colors     = parseArr(p.colors);
  const activeImg  = allImgs[activeIdx] || null;
  const wishlisted = isWishlisted(p.id);
  const isSoldOut  = p.stock === 0;

  const related = allProducts
    .filter(item => item.id !== p.id && (item.category === p.category || item.brand === p.brand))
    .slice(0, 4);

  function handleAddToBag() { addItem(p); }
  function handleBuyNow()   { addItem(p); closeQV(); openCheckout(); }
  function handleWA()       { window.open(buildEnquiryMessage(p), '_blank'); }

  const metaItem = (label, val) => val ? (
    <div style={{ fontSize: 12, display: 'flex', gap: 8, color: 'var(--grey-dark)', padding: '7px 0', borderBottom: '1px solid var(--grey)' }}>
      <span style={{ color: 'var(--dark)', fontWeight: 600, minWidth: 100, textTransform: 'uppercase', fontSize: 10, letterSpacing: '0.1em' }}>{label}</span>
      <span>{val}</span>
    </div>
  ) : null;

  return (
    <>
      <div
        ref={scrollRef}
        style={{ position: 'fixed', inset: 0, zIndex: 300, background: '#fff', overflowY: 'auto' }}
      >
        {/* ── Sticky top bar ── */}
        {/* ── Sticky top bar ── */}
<div style={{
  position: 'sticky', top: 0, zIndex: 10, background: '#fff',
  borderBottom: '1px solid var(--grey)',
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  padding: '14px 20px',
}}>
  {/* Back button — always visible */}
  <button onClick={closeQV}
    style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--grey-mid)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', padding: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
    <svg width={14} height={14} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M19 12H5M12 5l-7 7 7 7"/>
    </svg>
    Back to Collection
  </button>

  {/* Breadcrumb — hidden on mobile */}
  <div className="qv-breadcrumb" style={{ fontSize: 11, color: 'var(--grey-mid)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'flex', gap: 6, alignItems: 'center' }}>
    <span style={{ color: 'var(--dark)' }}>{p.brand}</span>
    <span>/</span>
    <span style={{ color: 'var(--dark)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
  </div>

  {/* Close button — hidden on mobile */}
  <button onClick={closeQV} className="qv-close-btn"
    style={{ background: 'none', border: '1px solid var(--grey)', cursor: 'pointer', color: 'var(--grey-mid)', display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', transition: 'all 0.2s' }}
    onMouseEnter={e => { e.currentTarget.style.background = 'var(--dark)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'var(--dark)'; }}
    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--grey-mid)'; e.currentTarget.style.borderColor = 'var(--grey)'; }}>
    <svg width={12} height={12} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
      <path d="M18 6L6 18M6 6l12 12"/>
    </svg>
    Close
  </button>
</div>

        {/* ── Page content ── */}
        <div className="qv-page-content" style={{ maxWidth: 1500, margin: '0 auto', padding: '48px 32px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'start' }} className="qv-full-grid">

            {/* LEFT — Image carousel */}
            <div onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
              <div style={{ background: 'var(--cream)', aspectRatio: '1', overflow: 'hidden', marginBottom: 12, position: 'relative' }}>
                {activeImg
                  // ? <img key={activeImg} src={activeImg} alt={`${p.brand} ${p.name}`}
                  //     style={{ width: '100%', height: '100%', objectFit: 'cover', mixBlendMode: 'multiply', transition: 'opacity 0.4s' }} />
                 ? <img
  key={activeImg}
  src={activeImg}
  alt={`${p.brand} ${p.name}`}
  style={{
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    mixBlendMode: 'multiply',
    transition: 'opacity 0.4s',
    cursor: 'zoom-in'
  }}
  onClick={() => {
    setImagePopup(true);
    setZoom(1);
  }}
/>
                  : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#d1d5db', letterSpacing: '0.15em', textTransform: 'uppercase' }}>No Image</div>
                }

                {allImgs.length > 1 && (
                  <>
                    <button
                      onClick={() => { setPaused(true); setActiveIdx(i => (i - 1 + allImgs.length) % allImgs.length); }}
                      style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', width:36, height:36, borderRadius:'50%', background:'rgba(255,255,255,0.85)', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 2px 8px rgba(0,0,0,0.1)', zIndex:2 }}>
                      <svg width={14} height={14} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
                    </button>
                    <button
                      onClick={() => { setPaused(true); setActiveIdx(i => (i + 1) % allImgs.length); }}
                      style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', width:36, height:36, borderRadius:'50%', background:'rgba(255,255,255,0.85)', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 2px 8px rgba(0,0,0,0.1)', zIndex:2 }}>
                      <svg width={14} height={14} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
                    </button>
                    <div style={{ position:'absolute', bottom:10, left:'50%', transform:'translateX(-50%)', display:'flex', gap:6, zIndex:2 }}>
                      {allImgs.map((_, i) => (
                        <button key={i} onClick={() => { setPaused(true); setActiveIdx(i); }}
                          style={{ width: i === activeIdx ? 20 : 6, height:6, borderRadius:3, background: i === activeIdx ? 'var(--dark)' : 'rgba(0,0,0,0.25)', border:'none', cursor:'pointer', padding:0, transition:'all 0.3s' }} />
                      ))}
                    </div>
                  </>
                )}
              </div>

              {allImgs.length > 1 && (
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {allImgs.map((u, i) => (
                    <button key={i} onClick={() => { setPaused(true); setActiveIdx(i); }}
                      style={{ width: 64, height: 64, border: `2px solid ${activeIdx === i ? 'var(--dark)' : 'transparent'}`, overflow: 'hidden', background: 'var(--cream)', cursor: 'pointer', padding: 0, transition: 'border-color 0.2s', flexShrink: 0 }}>
                      <img src={u} alt={`View ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', mixBlendMode: 'multiply' }} />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* RIGHT — Details */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div style={{ fontSize: 11, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600 }}>{p.brand}</div>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 300, color: 'var(--dark)', lineHeight: 1.15, letterSpacing: '-0.02em', margin: 0 }}>
                {p.name}
              </h1>

              {/* <div style={{ display: 'flex', alignItems: 'baseline', gap: 14 }}>
                <span style={{ fontSize: 24, fontWeight: 500, color: 'var(--dark)' }}>{fmt(p.price)}</span>
                {p.was && <span style={{ fontSize: 15, color: '#d1d5db', textDecoration: 'line-through' }}>{fmt(Number(p.was))}</span>}
                {p.was && (
                  <span style={{ fontSize: 11, color: 'var(--green)', fontWeight: 700, background: '#f0fdf4', padding: '2px 8px', letterSpacing: '0.1em' }}>
                    SAVE {Math.round((1 - p.price / p.was) * 100)}%
                  </span>
                )}
              </div> */}
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 14 }}>
                {(!p.price || Number(p.price) === 0)
                // ? <a href="https://wa.me/YOUR_WHATSAPP_NUMBER" target="_blank" rel="noreferrer" style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', padding: '10px 24px', background: 'var(--dark)', color: '#fff', textDecoration: 'none' }}>Contact Us for Price</a>
                ? <button
                    onClick={handleWA}
                    style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', padding: '10px 24px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer' }}>
                    Contact Us for Price
                  </button>
                : <>
                      <span style={{ fontSize: 24, fontWeight: 500, color: 'var(--dark)' }}>{fmt(p.price)}</span>
                      {p.was && <span style={{ fontSize: 15, color: '#d1d5db', textDecoration: 'line-through' }}>{fmt(Number(p.was))}</span>}
                      {p.was && (
                        <span style={{ fontSize: 11, color: 'var(--green)', fontWeight: 700, background: '#f0fdf4', padding: '2px 8px', letterSpacing: '0.1em' }}>
                          SAVE {Math.round((1 - p.price / p.was) * 100)}%
                        </span>
                      )}
                    </>
                }
              </div>

              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {isSoldOut && <span style={{ fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 700, padding: '4px 10px', background: 'var(--dark)', color: '#fff' }}>Sold Out</span>}
                {!isSoldOut && p.badge && <span style={{ fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600, padding: '4px 10px', background: '#fff', color: '#6b7280', border: '1px solid var(--grey)' }}>{p.badge}</span>}
                {!isSoldOut && p.stock > 0 && p.stock <= 3 && <span style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600, padding: '4px 10px', background: '#fff7ed', color: '#c2410c', border: '1px solid #fed7aa' }}>Only {p.stock} left</span>}
              </div>

              {colors.length > 0 && (
                <div>
                  <div style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--grey-dark)', fontWeight: 600, marginBottom: 10 }}>
                    Colour{colors.length > 1 ? 's' : ''}
                  </div>
                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    {colors.map((c, i) => (
                      <button key={i} type="button" title={c}
                        onClick={() => setSelectedColor(selectedColor === c ? null : c)}
                        style={{
                          width: 32, height: 32, borderRadius: '50%', background: c,
                          border: selectedColor === c ? '3px solid var(--dark)' : '2px solid rgba(0,0,0,0.12)',
                          cursor: 'pointer',
                          boxShadow: selectedColor === c ? '0 0 0 2px #fff, 0 0 0 4px var(--dark)' : '0 1px 3px rgba(0,0,0,0.15)',
                          transition: 'all 0.2s', padding: 0,
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {metaItem('Condition',    p.condition)}
                {metaItem('Dimensions',   p.dimensions)}
                {metaItem('Serial / Ref', p.serial_ref)}
                {metaItem('Category',     p.category)}
                {!isSoldOut && p.stock > 0 && metaItem('Availability', `${p.stock} in stock`)}
              </div>

              {p.description && (
                <p style={{ fontSize: 13, color: 'var(--grey-dark)', lineHeight: 1.9, margin: 0 }}>{p.description}</p>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
                {isSoldOut ? (
                  <div style={{ padding: '16px 0', textAlign: 'center', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--grey-mid)', background: 'var(--grey-light)', border: '1px solid var(--grey)' }}>
                    Sold Out
                  </div>
                ) : (
                  <>
                    <button onClick={handleBuyNow}
                      style={{ width: '100%', padding: 18, background: 'var(--dark)', color: '#fff', fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', fontWeight: 700, border: 'none', cursor: 'pointer', transition: 'background 0.2s' }}
                      onMouseEnter={e => e.target.style.background = 'var(--gold)'}
                      onMouseLeave={e => e.target.style.background = 'var(--dark)'}>
                      Buy Now
                    </button>
                    <button onClick={handleAddToBag}
                      style={{ width: '100%', padding: 16, border: '1px solid var(--dark)', background: '#fff', color: 'var(--dark)', fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s' }}
                      onMouseEnter={e => { e.target.style.background = 'var(--dark)'; e.target.style.color = '#fff'; }}
                      onMouseLeave={e => { e.target.style.background = '#fff'; e.target.style.color = 'var(--dark)'; }}>
                      Add to Bag
                    </button>
                  </>
                )}
                <button onClick={handleWA}
                  style={{ width: '100%', padding: 14, border: '1px solid #bbf7d0', background: '#f0fdf4', color: '#15803d', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Ask an Advisor
                </button>
                <button onClick={() => toggle(p.id)}
                  style={{ width: '100%', padding: 14, border: `1px solid ${wishlisted ? '#fca5a5' : 'var(--grey)'}`, background: wishlisted ? '#fef2f2' : '#fff', color: wishlisted ? '#dc2626' : 'var(--grey-dark)', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' }}>
                  {wishlisted ? '♥ Remove from Wishlist' : '♡ Save to Wishlist'}
                </button>
              </div>
            </div>
          </div>

          {/* ── Related Products ── */}
          {related.length > 0 && (
            <div style={{ marginTop: 80, paddingTop: 48, borderTop: '1px solid var(--grey)' }}>
              <div style={{ marginBottom: 32 }}>
                <div style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--grey-mid)', marginBottom: 8 }}>You May Also Like</div>
                <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(20px,2.5vw,30px)', fontWeight: 300, color: 'var(--dark)', margin: 0, letterSpacing: '-0.01em' }}>
                  Related Pieces
                </h2>
              </div>
              {/* ✅ className for responsive grid */}
              <div className="related-grid">
                {related.map(item => <ProductCard key={item.id} product={item} />)}
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .qv-full-grid {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
          }
        }

        /* ✅ Related products grid — 2 per row on mobile */
        .related-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 48px 24px;
        }

        @media (max-width: 768px) {
          .related-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 32px 12px;
          }
            
        }
        /* ── Top bar mobile ── */
@media (max-width: 768px) {
  .qv-breadcrumb { display: none !important; }
  .qv-close-btn  { display: none !important; }
}
  /* ── Reduce left/right padding on mobile ── */
@media (max-width: 768px) {
  .qv-page-content {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }
}
      `}</style>
      {imagePopup && (
  <div
    onClick={() => {
      setImagePopup(false);
      setZoom(1);
    }}
    style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.9)',
      zIndex: 99999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'zoom-out'
    }}
  >
    <img
      src={activeImg}
      alt="Preview"
      onClick={(e) => e.stopPropagation()}
      onWheel={(e) => {
        e.preventDefault();

        if (e.deltaY < 0) {
          setZoom(prev => Math.min(prev + 0.2, 5));
        } else {
          setZoom(prev => Math.max(prev - 0.2, 1));
        }
      }}
      style={{
        maxWidth: '90vw',
        maxHeight: '90vh',
        objectFit: 'contain',
        transform: `scale(${zoom})`,
        transition: 'transform 0.15s ease',
        cursor: zoom > 1 ? 'grab' : 'zoom-in'
      }}
    />

    <button
      onClick={() => {
        setImagePopup(false);
        setZoom(1);
      }}
      style={{
        position: 'absolute',
        top: 20,
        right: 20,
        width: 40,
        height: 40,
        border: 'none',
        borderRadius: '50%',
        background: '#fff',
        cursor: 'pointer',
        fontSize: '22px',
        fontWeight: 'bold'
      }}
    >
      ×
    </button>
  </div>
)}
    </>
  );
}